// extracted by mini-css-extract-plugin
module.exports = {"energy-table":"energy-table_energy-table__L3RoW","energy-cost-result":"energy-table_energy-cost-result__2DACh","el-items":"energy-table_el-items__pbw19"};